import type { CookieConsentsConfigDTO } from "./dtos";

export const COOKIE_CONSENTS_SERVICE = "CookieConsentsService";

export type CookieConsentsConfig = CookieConsentsConfigDTO;
